import { QueryConfig } from "store/utils/query-config";

export const scheduledReportsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
